import axios from 'axios';
import baseUrl from '../config/baseURL';
import { getAuthToken } from '../services/auth';
import {
  getMessaging,
  deleteToken,
  getToken,
  onMessage,
} from 'firebase/messaging';
import { firebaseApp, messaging } from './firebase-config';
import { vapIdKey } from '../config/firebase-config';

export const saveFCMTokenToServer = async (fcmToken: string) => {
  try {
    const token = await getAuthToken();

    if (!token || !token.data) {
      console.error('❌ No auth token found.');
      return { success: false, data: 'No authentication token available' };
    }

    const header_token = `Bearer ${token.data}`; // or `Token ${token.data}` depending on backend
    const headers = {
      Authorization: header_token,
      'Content-Type': 'application/json',
    };

    const data = { token: fcmToken };

    const endpoint = `${baseUrl}/core/register-device/`;
    const response = await axios.post(endpoint, data, { headers });

    if (response.status === 201 || response.status === 200) {
      console.log('✅ FCM Token saved successfully:', response.data);
      return { success: true, data: response.data };
    } else {
      console.error('⚠️ Failed to save FCM token:', response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error('❌ Error saving FCM token:', error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const resetFCMToken = async () => {
  try {
    const messaging = getMessaging(firebaseApp);
    const currentToken = await getToken(messaging);

    if (currentToken) {
      console.log('Deleting existing token:', currentToken);
      await deleteToken(messaging);
      console.log('Token deleted, re-requesting permission...');
    }

    // Re-request permission
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const newToken = await getToken(messaging, {
        vapidKey: vapIdKey,
      });
      console.log('New FCM Token:', newToken);
      return newToken;
    } else {
      console.warn('Permission denied.');
      return null;
    }
  } catch (error) {
    console.error('Error resetting token:', error);
  }
};

export const listenForNotifications = async () => {
  const msg = await messaging();
  if (!msg) return;

  try {
    onMessage(msg, (payload: any) => {
      console.log('📩 Received message in foreground:', payload);
      window.dispatchEvent(
        new CustomEvent('pipeline:notification', {
          detail: payload,
        }),
      );
      new Notification(payload.notification.title, {
        body: payload.notification.body,
      });
    });
  } catch (err) {
    console.error('Error getting token:', err);
  }
};
